import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ReactedUsersQuery: GraphQLTaggedNode = graphql`
	query ReactedUsersQuery(
		$contentId: String!
		$containerId: String!
		$containerType: ContainerType!
		$contentType: GraphQLReactionContentType!
		$emojiId: String!
	) {
		reactedUsers(
			contentId: $contentId
			containerId: $containerId
			containerType: $containerType
			contentType: $contentType
			emojiId: $emojiId
		) {
			count
			emojiId
			reacted
			confluencePerson {
				accountId
				displayName
				profilePicture {
					path
				}
			}
		}
	}
`;
